@let account = this.account();
@let isBankCard = accountType() === accountTypeEnum.BankCard;
@let isSelected = selected();

<div class="skin">
  <iw-card-view
    [size]="'xxs'"
    [account]="account"
    [accountType]="accountType()"
  />
  @if (!isSelected) {
    <fu-icon class="chosen-icon" iconName="succeeded" size="16" />
  }
</div>

<div class="details">
  <div class="name">
    {{
      "account.name" + (isBankCard ? ".card" : "")
        | translate: { currency: account.currency?.symbol }
    }}
    @if (isSelected) {
      <fu-icon class="arrow" iconName="arrow" size="20" />
    }
  </div>

  @if (isSelected) {
    <div class="balance">
      <div class="currency">{{ account.currency?.symbol }}</div>

      <div class="amount">{{ account.balance }}</div>
    </div>
  } @else {
    <div class="currency">{{ account.currency?.name }}</div>
  }
</div>

@if (!isSelected) {
  <div class="balances">
    <div class="balance">
      <div class="currency">{{ account.currency?.symbol }}</div>

      <div class="amount">{{ account.balance }}</div>
    </div>

    @if (account.balanceInDefaultCurr) {
      <div class="balance converted">
        <div class="currency">{{ defaultCurrency() }}</div>

        <div class="amount">
          {{ account.balanceInDefaultCurr }}
        </div>
      </div>
    }
  </div>
}
